import React, { type ReactNode, useId, useRef, useState } from "react";
import { Icon } from "components";
import { Tooltip } from "reactstrap";
import * as Scrivito from "scrivito";

type TooltipIconProps = {
  description?: ReactNode;
};

export const TooltipIcon = Scrivito.connect(
  ({ description }: TooltipIconProps) => {
    const [open, setOpen] = useState(false);
    const inputRef = useRef<HTMLDivElement | null>(null);
    const tooltipTargetId = useId().replace(/[^a-zA-Z0-9_-]/g, "");
    const toggle = () => setOpen(!open);

    if (!description) {
      return null;
    }

    return (
      <div
        id={tooltipTargetId}
        className="position-absolute top-0 end-0 p-1 cursor-pointer"
        onClick={toggle}
        ref={inputRef}
        onMouseLeave={() => open && toggle()}
      >
        <Icon
          iconName="circle-exclamation-regular"
          className="icon-20 text-gray-400"
          data-testid="tooltip-icon"
        />
        <Tooltip
          isOpen={open}
          target={tooltipTargetId}
          placement="top"
          className="text-gray-400"
        >
          {description}
        </Tooltip>
      </div>
    );
  },
);
